<template>
  <div id="" class="">
      <el-dialog title="审核" :visible.sync="isShowdialog" :before-close="cancel" width="20%">
        <el-form ref="form" label-width="80px" size="mini" >
          <el-row style="display: flex;justify-content: center">
            <el-col :span="22">
              <el-form-item label="审核状态" required>
                <el-select v-model="audit" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="display:flex;justify-content: flex-end">
            <el-form-item size="mini">
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
export default {
  props:['dialogVisible','machine'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
    },
    machine(val){
      if(val.processStatus === 'PENDING'){
        this.options = [{
          value: 'AGREE',
          label: '审核通过'
        }, {
          value: 'DISAGREE',
          label: '审核不通过'
        }, {
          value: 'DIRECT',
          label: '直接退款'
        }]
      }else if(val.processStatus === 'SHIPPED'){
        this.options = [{
          value: 'FINISH',
          label: '验货退款'
        }, {
          value: 'DISAGREE',
          label: '验货不通过'
        }]
      }
    }
  },
  data() {
    return {
      isShowdialog: false,
      dialogTitle: '',
      returnTime: '',
      uploading: '',
      options: [],
      audit: ''
    }
  },
  methods:{
    cancel(done){
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowdialog,dialog:'refund'})
    },

    async onSubmit() {
      this.uploading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });
      try{
        let result = await this.$request.set_message('refund',{id: this.machine._id,processStatus: this.audit});
        this.$message(result);
      } catch(e) {
        this.$message(e);
      } finally {
        this.audit = '';
        this.uploading.close();
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'refund',refresh:true})
        this.isShowdialog = false;
      }
    },

  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/ProcessDialog.vue